<div class="row basic-component" #modalTarget>
 <div class="col-sm-12">
     <form [formGroup]="establishmentSectionForm" name="establishmentSectionForm" novalidate role="form">
         <div class="row">
             <!-- <div class="col-sm-12 section-title pull-left">
                 Establishment(s)
                 <span class="establishments">(<a href="javascript:void(0);" (click)="estabModalOpen($event)">
                  edit
              </a>)</span>
             </div> -->
             <div class="col-sm-12 section-title" >
              Establishment(s)
                 <span class="establishments">(<a href="javascript:void(0);" (click)="estabModalOpen($event)" (keydown.enter)="estabModalOpen($event)" tabindex="0" aria-label="Edit Establishment(s)">
                  edit
              </a>)</span>
              <span class="float-end create-company-link" *ngIf="canCreateCompany">
                <a href="javascript:void(0);" (click)="showCompanyDialog()" (keydown.enter)="showCompanyDialog()" tabindex="0" aria-label="Create new company"
                    class="create-company-link" id="create-company"><small>Create new company</small></a>
              </span>
          </div>

         </div>
         <div class="row">
             <div class="col-sm-12 no-padding">
                 <table formArrayName="estabCompanyFormArray" class="table table-inline table-bordered">
                     <tbody>
                         <tr>
                             <th class="text-center">
                                 <label class="form-label-control">Company Name</label>
                             </th>
                             <th class="text-center">
                                 <label class="form-label-control">Company DUNS</label>
                             </th>
                             <th class="text-center">
                                 <label class="form-label-control">Business Operations</label>
                             </th>
                         </tr>
                         <tr formGroupName="{{i}}"
                         *ngFor="let item of establishmentSectionForm.get('estabCompanyFormArray')['controls']; let i = index">
                             <td class="td-30">


                                 <div class='icon-align-left' *ngIf="!isCompanyLatest(item.value.companyRevisionId); else displayName">
                                     <app-warning-icon #warningContact [name]="'(' + item.value.duns + ') ' + item.value.companyName" [type]="iconTypeCompany"></app-warning-icon>
                                </div>


                              <ng-template #displayName>
                                <label class="label-directive" [attr.aria-label]="'Company name is ' + item.value.companyName" tabindex="0">{{item.value.companyName}}</label>
                              </ng-template>

                             </td>
                             <td class="td-20">
                              <label class="label-directive" [attr.aria-label]="'Company DUNS is ' + item.value.duns" tabindex="0">{{item.value.duns}}</label>
                             </td>
                             <td><label class="label-directive" [attr.aria-label]="'Business Operation is ' + item.value.busOps" tabindex="0">{{item.value.busOps}}</label></td>
                         </tr>

                     </tbody>
                 </table>
             </div>
         </div>
     </form>
 </div>
</div>

<app-establishment-modal #establishmentModal [llFormData]='llFormData' (modalEstabData)='saveModalForm($event)' [changedNdcCode]="changedNdcCode" [bDeleteProduct]='bDeleteProduct'>
</app-establishment-modal>

<!-- Company Detail Dialog box -->
<ejs-dialog id='dialog' #companyDialog isModal='true'
            [animationSettings]='animationSettings' [visible]='hidden' width="80%">
    <ng-template #content class="modal-header">
        <form name="modalCompanyForm">
            <div class="card">
                <div class="card-header bg-primary">
                    <h4 class="card-title text-white" tabindex="0">Company Details</h4>
                </div>

                <div class="card-body">
                    <app-company-details #companyDetails (companyOutput)="modalCompany($event)"
                        (cancelButtonClickedOutput)="companyDialogCancelButtonClicked()"
                        [parentComponentInput]="parentComponent">
                    </app-company-details>
                </div>

            </div>

        </form>
    </ng-template>
</ejs-dialog>
